import { createFileRoute } from '@tanstack/react-router';
import { useAuth } from '../hooks/useAuth.js';

export const Route = createFileRoute('/pending')({
  component: PendingPage,
});

function PendingPage() {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen grid place-items-center p-8">
      <div className="max-w-md text-center space-y-4">
        <h1 className="text-2xl font-bold">Account in Prüfung</h1>
        <p className="text-muted-foreground">
          Hallo {user?.name ?? user?.email}, dein Account ({user?.email}) ist
          angelegt, aber dir wurde noch keine Rolle zugewiesen. Internal Staff
          muss dich freischalten.
        </p>
        <button
          onClick={() => logout()}
          className="px-6 py-2 rounded-lg border border-border hover:bg-accent"
        >
          Abmelden
        </button>
      </div>
    </div>
  );
}
